import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import { router } from './router'
import { initializePrivy } from './lib/privy'
import './styles/main.css'

import en from './locales/en.json'
import id from './locales/id.json'
import ar from './locales/ar.json'

const LANGUAGE_KEY = 'nomadian_language'

function getSavedLocale(): string {
    try {
        const saved = localStorage.getItem(LANGUAGE_KEY)
        if (saved && ['en', 'id', 'ar'].includes(saved)) return saved
    } catch {
        // localStorage not available
    }
    return 'en'
}

const savedLocale = getSavedLocale()

const i18n = createI18n({
    legacy: false,
    locale: savedLocale,
    fallbackLocale: 'en',
    messages: {
        en,
        id,
        ar,
    }
})

// Apply RTL if Arabic is saved
if (savedLocale === 'ar') {
    document.documentElement.setAttribute('dir', 'rtl')
    document.documentElement.setAttribute('lang', 'ar')
} else {
    document.documentElement.setAttribute('lang', savedLocale)
}

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(i18n)
app.mount('#app')

// Initialize Privy SDK in background (non-blocking)
initializePrivy().catch((err) => {
    if (import.meta.env.DEV) console.warn('[Privy] Initialization failed:', err)
})
